// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderTwoTone";
import AntdIcon from '../components/AntdIcon';

var FolderTwoTone = function FolderTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderTwoToneSvg
  }));
};

FolderTwoTone.displayName = 'FolderTwoTone';
export default React.forwardRef(FolderTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderTwoTone.js
// module id = 1203
// module chunks = 0